export default function (state, cb) {
    if (cb) {
        state.cbs.push(cb);
    } else {
        state.cbs.forEach(i => {
            i(state);
        });
        state.cbs = [];
    }
}